import React from 'react';
import Typeset from '@components/base_typeset/component';
import store from '@utils/store';
import { numFormatToCurrency } from '@utils';
import DeLogo from '@active-channel/images/logomark_douwe-egberts.svg';
import DeLogoSmall from '@active-channel/images/logomark_douwe-egberts-xxsmall.svg';
import Text from '@text';
import PropTypes from 'prop-types';
import { t } from '@utils/i18n';

import './styles.scss';

const LoyaltyPrice = (props) => {
  const { prices, size } = props;
  if (!prices) return null;

  const loyaltyPrice = prices.find(
    (price) => price.label === t('pricing.text.depoints')
  );
  const regularPrice = prices.find(
    (price) => price.label === t('pricing.text.standard')
  );
  const formattedPrice = numFormatToCurrency(regularPrice.amount);

  const renderLargeBlock = () => {
    return (
      <div className="loyalty-price large">
        <div className="image-col">
          <DeLogo className="de-logo" />
        </div>
        <div className="details-col">
          <div className="loyalties">
            <Typeset tag="div" scale="6" bold>
              {loyaltyPrice.amount}
            </Typeset>
            <div className="label">
              <Text html>de-loyalty.price.large.lable</Text>
            </div>
          </div>
          <div className="regular-price">
            <Text>de-loyalty.price.or</Text>&nbsp;
            {store.currencySign}
            {formattedPrice}
          </div>
        </div>
      </div>
    );
  };

  const renderMediumBlock = () => {
    return (
      <div className="loyalty-price medium">
        <div className="loyalties">
          <div className="amount">
            {loyaltyPrice.amount}
            <DeLogoSmall className="de-logo" />
          </div>
          <div className="label">
            <Text>de-loyalty.price.medium.lable</Text>
          </div>
        </div>
        <div className="seperator"></div>
        <div className="regular-price">
          <div className="label">
            <Text>de-loyalty.price.or</Text>
          </div>
          <div className="amount">{formattedPrice}</div>
        </div>
      </div>
    );
  };

  const renderSmallBlock = () => {
    return (
      <div className="loyalty-price small">
        <div className="loyalties">
          <div className="amount">
            {loyaltyPrice.amount}
            <DeLogoSmall className="de-logo" />
          </div>
          <div className="label">
            <Text>de-loyalty.price.medium.lable</Text>
          </div>
        </div>
        <div className="seperator"></div>
        <div className="regular-price">
          <div className="label">
            <Text>de-loyalty.price.or</Text>
          </div>
          <div className="amount">{formattedPrice}</div>
        </div>
      </div>
    );
  };

  return {
    small: renderSmallBlock(),
    medium: renderMediumBlock(),
    large: renderLargeBlock(),
  }[size];
};

LoyaltyPrice.propTypes = {
  prices: PropTypes.array,
  size: PropTypes.string,
};

export default LoyaltyPrice;
